(function() {
  'use strict';

  // Configuration
  var CONFIG = {
    cookieName: 'homediq_geo_preference',
    cookieDays: 30,
    geoApiUrl: 'https://get.geojs.io/v1/ip/country.json',
    fallbackDomain: 'https://homediq.com',
    // Domains to exclude from redirect (local development, Shopify preview, etc.)
    excludedDomains: ['localhost', '127.0.0.1', 'myshopify.com'],
    countryMapping: {
      'NL': { domain: 'homediq.nl', primaryLang: 'nl', hreflangMain: 'nl', hreflangAlt: 'en-NL' },
      'DE': { domain: 'homediq.de', primaryLang: 'de', hreflangMain: 'de', hreflangAlt: 'en-DE' },
      'AT': { domain: 'homediq.at', primaryLang: 'de', hreflangMain: 'de-AT', hreflangAlt: 'en-AT' }
    }
  };

  // Check if we're on a development/excluded domain
  function isExcludedDomain() {
    var hostname = window.location.hostname;
    return CONFIG.excludedDomains.some(function(domain) {
      return hostname === domain || hostname.includes(domain);
    });
  }

  // Check if we're on homediq.com (the only domain where geo-redirect should run)
  function isHomediqCom() {
    var hostname = window.location.hostname;
    return hostname === 'homediq.com' || hostname === 'www.homediq.com';
  }

  // Check if we're in Shopify theme preview mode
  function isThemePreview() {
    var urlParams = new URLSearchParams(window.location.search);
    // Shopify adds preview_theme_id when previewing unpublished themes
    if (urlParams.has('preview_theme_id')) {
      return true;
    }
    // Also check for Shopify preview bar in DOM
    if (document.querySelector('#preview-bar-iframe, #shopify-section-announcement-bar[data-shopify-editor-block]')) {
      return true;
    }
    return false;
  }

  // Check if user came from another Homediq domain (internal navigation)
  function isInternalNavigation() {
    var referrer = document.referrer;
    if (!referrer) return false;

    try {
      var referrerHost = new URL(referrer).hostname;
      // Check if referrer is from any Homediq domain
      if (referrerHost.includes('homediq.')) {
        return true;
      }
    } catch (e) {
      // URL parsing failed
    }
    return false;
  }

  // Cookie utilities
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  // Get current domain
  function getCurrentDomain() {
    return window.location.hostname;
  }

  // Check if we're on a homepage
  function isHomepage() {
    var path = window.location.pathname;
    // Homepage patterns: /, /en, /en/, /de, /de/, etc.
    return path === '/' || /^\/[a-z]{2}\/?$/.test(path);
  }

  // Get URL from hreflang tag
  function getHreflangUrl(hreflang) {
    var link = document.querySelector('link[hreflang="' + hreflang + '"]');
    return link ? link.href : null;
  }

  // Determine target URL based on country (always use primary language)
  function getTargetUrl(countryCode) {
    var countryConfig = CONFIG.countryMapping[countryCode];

    if (!countryConfig) {
      // Country not in our markets, redirect to fallback (homediq.com)
      return CONFIG.fallbackDomain;
    }

    // Always use the country's primary language - let users switch language manually
    var hreflang = countryConfig.hreflangMain;

    // Try to get URL from hreflang tag
    var url = getHreflangUrl(hreflang);

    if (!url) {
      // Fallback: construct URL manually (always root path for primary language)
      var protocol = 'https://';
      url = protocol + countryConfig.domain + '/';
    }

    return url;
  }

  // Check if redirect is needed (not already on target domain/path)
  function shouldRedirect(targetUrl) {
    if (!targetUrl) return false;

    var currentUrl = window.location.href.replace(/\/$/, ''); // Remove trailing slash
    var target = targetUrl.replace(/\/$/, '');

    // Don't redirect if already on target
    if (currentUrl === target) return false;

    // Parse URLs to compare
    try {
      var currentParsed = new URL(currentUrl);
      var targetParsed = new URL(targetUrl);

      // Check if same domain and path
      if (currentParsed.hostname === targetParsed.hostname &&
          currentParsed.pathname.replace(/\/$/, '') === targetParsed.pathname.replace(/\/$/, '')) {
        return false;
      }
    } catch (e) {
      // URL parsing failed, allow redirect
    }

    return true;
  }

  // Main redirect logic
  function initGeoRedirect() {
    // Only run on homediq.com
    if (!isHomediqCom()) return;

    // Skip on development/preview domains
    if (isExcludedDomain()) return;

    // Skip on Shopify theme preview
    if (isThemePreview()) return;

    // Only run on homepage
    if (!isHomepage()) return;

    // Check if user came from another Homediq domain (they manually switched)
    if (isInternalNavigation()) {
      // Set cookie on this domain to remember their preference
      setCookie(CONFIG.cookieName, 'skip', CONFIG.cookieDays);
      return;
    }

    // Check if user has a saved preference (manually switched before)
    var savedPreference = getCookie(CONFIG.cookieName);
    if (savedPreference === 'skip') {
      return;
    }

    // Fetch country from geojs.io
    fetch(CONFIG.geoApiUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Geo API request failed');
        return response.json();
      })
      .then(function(data) {
        var countryCode = data.country;

        if (!countryCode) {
          return;
        }

        var targetUrl = getTargetUrl(countryCode);

        if (shouldRedirect(targetUrl)) {
          setCookie(CONFIG.cookieName, 'redirected', CONFIG.cookieDays);
          window.location.href = targetUrl;
        }
      })
      .catch(function() {
        // Graceful degradation: if geo API fails, do nothing
      });
  }

  // Mark preference when user manually changes language/country
  // This function can be called from the language selector
  window.markGeoPreference = function() {
    setCookie(CONFIG.cookieName, 'skip', CONFIG.cookieDays);
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeoRedirect);
  } else {
    initGeoRedirect();
  }
})();
